<div [class.faded]="hasLoaded" class="fade-in">
    <mat-card>
        <mat-card-header>
            <mat-card-title>
                <h1>
                    <mat-icon color="primary">
                        check_circle
                    </mat-icon>
                    Success!
                </h1>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            Your message has been sent successfully.
            <br>
            <br>
            <div class="button-container">
                <button [class.loaded]="hasLoaded" class="mat-raised-button mat-primary" mat-button
                        [routerLink]="messageStatusRoute"> View Message Status
                </button>
                <button [class.loaded]="hasLoaded" class="mat-raised-button mat-primary" mat-button
                        routerLink="/sendMessage"> Send a Message
                </button>
            </div>
        </mat-card-content>
    </mat-card>
</div>
